/*
 * Ask Billy opens Re:amaze with Reamaze.popup() when that script is present.
 * Shopify Inbox remains the fallback. Inbox DOM access stays inside openDirectLine().
 */
(function () {
  var NATIVE_STYLE_ID = 'cc-direct-line-native-css';
  var HIDE_STYLE_ATTR = 'data-cc-direct-line-hide';
  var preferNative = false;
  var POP_SELECTORS = [
    '[id*="popconvert" i]',
    '[id*="pop-convert" i]',
    '[class*="popconvert" i]',
    '[class*="pop-convert" i]',
    '.pc-popup',
    '.pc-modal',
    '.pc-overlay'
  ];

  function openDirectLine(command) {
    var WIDGET_SELECTOR = 'shopify-chat, inbox-online-store-chat';
    var TOGGLE_SELECTOR = 'button.activator, button[part="activator"], [data-spec="toggle-button"], .chat-app > button, .chat-toggle';
    var HIDE_CSS = [
      'button.activator,',
      'button[part="activator"],',
      '.activator-nudge,',
      '[data-spec="toggle-button"],',
      '.chat-toggle {',
      'display: none !important;',
      'opacity: 0 !important;',
      'visibility: hidden !important;',
      'pointer-events: none !important;',
      '}'
    ].join('');

    function knownWidgets() {
      return document.querySelectorAll(WIDGET_SELECTOR + ', #ShopifyChat');
    }

    function toggleIn(root) {
      if (!root || !root.querySelector) return null;
      return root.querySelector(TOGGLE_SELECTOR);
    }

    function findToggle(widget) {
      var found = null;
      function walk(root) {
        if (!root || !root.querySelectorAll || found) return;
        var toggle = toggleIn(root);
        if (toggle) {
          found = { el: toggle, root: root };
          return;
        }
        var nodes = root.querySelectorAll('*');
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].shadowRoot) walk(nodes[i].shadowRoot);
        }
      }
      if (widget && widget.shadowRoot) walk(widget.shadowRoot);
      return found;
    }

    function openState(widget) {
      if (!widget) return 'unknown';
      if (widget.hasAttribute('is-open')) {
        return widget.getAttribute('is-open') === 'true' ? 'open' : 'closed';
      }
      var found = findToggle(widget);
      if (found && found.el.hasAttribute('aria-expanded')) {
        return found.el.getAttribute('aria-expanded') === 'true' ? 'open' : 'closed';
      }
      return 'unknown';
    }

    function iframeDocument(iframe) {
      if (!iframe || !iframe.contentWindow) return null;
      try {
        return iframe.contentWindow.document;
      } catch (error) {
        return null;
      }
    }

    function iframeButton(iframe) {
      var doc = iframeDocument(iframe);
      if (!doc) return null;
      return doc.getElementById('dummy-chat-button') || toggleIn(doc);
    }

    function findLauncher() {
      var widget = document.querySelector(WIDGET_SELECTOR);
      var modern = widget && findToggle(widget);
      if (modern) {
        if (modern.el.getAttribute('aria-expanded') === 'true' || openState(widget) === 'open') {
          return { alreadyOpen: true, el: modern.el, root: modern.root };
        }
        return { el: modern.el, root: modern.root };
      }

      var dummyIframe = document.getElementById('dummy-chat-button-iframe');
      var dummy = iframeButton(dummyIframe);
      if (dummy) return { el: dummy, root: null, iframe: dummyIframe };

      var legacy = document.getElementById('ShopifyChat');
      if (openState(legacy) === 'open') return { alreadyOpen: true, root: legacy.shadowRoot || null };
      var legacyButton = toggleIn(legacy && legacy.shadowRoot);
      if (legacyButton) return { el: legacyButton, root: legacy.shadowRoot };
      var legacyFrameButton = iframeButton(legacy);
      if (legacyFrameButton) return { el: legacyFrameButton, root: null, iframe: legacy };

      return null;
    }

    function anyWidgetOpen() {
      var widgets = knownWidgets();
      for (var i = 0; i < widgets.length; i++) {
        if (openState(widgets[i]) === 'open') return true;
      }
      return false;
    }

    function stateKnownAndClosed() {
      var widgets = knownWidgets();
      if (!widgets.length) return false;
      var sawState = false;
      for (var i = 0; i < widgets.length; i++) {
        var state = openState(widgets[i]);
        if (state === 'open') return false;
        if (state === 'closed') sawState = true;
      }
      return sawState;
    }

    function pageHideStyle() {
      if (document.getElementById(NATIVE_STYLE_ID)) return;
      var style = document.createElement('style');
      style.id = NATIVE_STYLE_ID;
      style.textContent = [
        'shopify-chat {',
        'pointer-events: none !important;',
        '}',
        '#dummy-chat-button-iframe,',
        '#shopify-chat-dummy {',
        'opacity: 0 !important;',
        'visibility: hidden !important;',
        'pointer-events: none !important;',
        'width: 1px !important;',
        'height: 1px !important;',
        'overflow: hidden !important;',
        'position: fixed !important;',
        'right: 0 !important;',
        'bottom: 0 !important;',
        '}'
      ].join('');
      document.head.appendChild(style);
    }

    function eachOpenShadow(widget, fn) {
      function walk(root) {
        if (!root || !root.querySelectorAll) return;
        fn(root);
        var nodes = root.querySelectorAll('*');
        for (var i = 0; i < nodes.length; i++) {
          if (nodes[i].shadowRoot) walk(nodes[i].shadowRoot);
        }
      }
      if (widget && widget.shadowRoot) walk(widget.shadowRoot);
    }

    function concealRoot(root) {
      if (!root || !root.appendChild || !root.querySelector) return;
      if (!root.querySelector(TOGGLE_SELECTOR) && !root.querySelector('.activator-nudge')) return;
      if (!root.querySelector('style[' + HIDE_STYLE_ATTR + ']')) {
        var style = document.createElement('style');
        style.setAttribute(HIDE_STYLE_ATTR, '');
        style.textContent = HIDE_CSS;
        root.appendChild(style);
      }
      var launchers = root.querySelectorAll(TOGGLE_SELECTOR + ', .activator-nudge');
      for (var i = 0; i < launchers.length; i++) {
        launchers[i].style.setProperty('visibility', 'hidden', 'important');
        launchers[i].style.setProperty('pointer-events', 'none', 'important');
        launchers[i].style.setProperty('opacity', '0', 'important');
      }
    }

    function concealIframe(iframe) {
      var doc = iframeDocument(iframe);
      if (!doc || !doc.head || doc.getElementById('cc-direct-line-iframe-hide')) return;
      var style = doc.createElement('style');
      style.id = 'cc-direct-line-iframe-hide';
      style.textContent = '#dummy-chat-button, .chat-toggle, button.activator { opacity: 0 !important; visibility: hidden !important; pointer-events: none !important; }';
      doc.head.appendChild(style);
    }

    function revealNative() {
      var pageStyle = document.getElementById(NATIVE_STYLE_ID);
      if (pageStyle) pageStyle.remove();
      knownWidgets().forEach(function (widget) {
        eachOpenShadow(widget, function (root) {
          var style = root.querySelector('style[' + HIDE_STYLE_ATTR + ']');
          if (style) style.remove();
          var launchers = root.querySelectorAll(TOGGLE_SELECTOR + ', .activator-nudge');
          for (var i = 0; i < launchers.length; i++) {
            launchers[i].style.removeProperty('visibility');
            launchers[i].style.removeProperty('pointer-events');
            launchers[i].style.removeProperty('opacity');
          }
        });
      });
      var dummy = document.getElementById('dummy-chat-button-iframe');
      var dummyDoc = iframeDocument(dummy);
      var dummyStyle = dummyDoc && dummyDoc.getElementById('cc-direct-line-iframe-hide');
      if (dummyStyle) dummyStyle.remove();
    }

    if (command === 'is-open') return anyWidgetOpen();
    if (command === 'closed') return stateKnownAndClosed();

    var launcher = findLauncher();

    if (command === 'probe') return !!launcher;
    if (command === 'reveal') {
      revealNative();
      return true;
    }
    if (command === 'conceal') {
      if (!launcher) return false;
      pageHideStyle();
      concealRoot(launcher.root);
      if (launcher.iframe) concealIframe(launcher.iframe);
      knownWidgets().forEach(function (widget) {
        eachOpenShadow(widget, concealRoot);
      });
      return true;
    }
    if (window.Reamaze && typeof window.Reamaze.popup === 'function') {
      try {
        var wrap = document.getElementById('reamaze-wrapper');
        var alreadyOpen = wrap && wrap.parentElement && wrap.parentElement.classList.contains('reamaze-visible');
        if (!alreadyOpen) window.Reamaze.popup();
        return true;
      } catch (error) {}
    }
    if (!launcher) return false;
    if (launcher.alreadyOpen) return true;
    try {
      launcher.el.click();
      return true;
    } catch (error) {
      return false;
    }
  }

  function popConvertVisible() {
    for (var i = 0; i < POP_SELECTORS.length; i++) {
      var nodes;
      try {
        nodes = document.querySelectorAll(POP_SELECTORS[i]);
      } catch (error) {
        continue;
      }
      for (var j = 0; j < nodes.length; j++) {
        var el = nodes[j];
        var style = window.getComputedStyle(el);
        if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) continue;
        var rect = el.getBoundingClientRect();
        if (rect.width > 48 && rect.height > 48) return true;
      }
    }
    return false;
  }

  function rectsOverlap(a, b) {
    return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  }

  function buyZoneBlocked() {
    if (/\/checkouts?(\/|$)/.test(window.location.pathname)) return true;
    var launcher = document.getElementById('cc-direct-line');
    if (!launcher) return false;
    var zone = launcher.getBoundingClientRect();
    if (zone.width < 2 || zone.height < 2) return false;
    var nodes = document.querySelectorAll([
      'button[name="add"]',
      '.single_add_to_cart_button',
      '.single-add-to-cart-button',
      'button[name="checkout"]',
      '.checkout-button',
      'quantity-selector',
      '.quantity',
      'input[name="quantity"]',
      '[data-cc-window-size]',
      '[data-cc-door-pkg]',
      '.cc-door-pkg',
      '.product-form__input select',
      '.product-form__input input[type="radio"]'
    ].join(','));
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el === launcher || launcher.contains(el)) continue;
      var style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity) === 0) continue;
      var rect = el.getBoundingClientRect();
      if (rect.width < 8 || rect.height < 8) continue;
      if (rect.height > 360 || rect.width > window.innerWidth * 0.95) continue;
      if (rectsOverlap(zone, rect)) return true;
    }
    return false;
  }

  function syncPage() {
    document.documentElement.classList.toggle('cc-direct-line-on', !preferNative);
    document.documentElement.classList.remove('cc-direct-line-chat-open');
    if (!preferNative && openDirectLine('probe')) openDirectLine('conceal');
    if (preferNative) openDirectLine('reveal');
    document.documentElement.classList.toggle('cc-direct-line-overlay', popConvertVisible());
    document.documentElement.classList.toggle('cc-direct-line-yield', buyZoneBlocked());
  }

  function confirmOpened() {
    window.setTimeout(function () {
      if (openDirectLine('is-open')) {
        preferNative = false;
        openDirectLine('conceal');
      }
      syncPage();
    }, 800);
  }

  function contextFrom(trigger) {
    var root = document.getElementById('cc-direct-line');
    var location = (trigger && trigger.getAttribute('data-cc-location')) || 'launcher';
    var source = (trigger && trigger.getAttribute('data-cc-source')) || location;
    return {
      page_type: (root && root.getAttribute('data-page-type')) || '',
      location: location,
      product: (root && root.getAttribute('data-product')) || '',
      source: source
    };
  }

  function publishDirectLine(name, data) {
    if (!(window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function')) return;
    Shopify.analytics.publish(name, {
      page_type: data.page_type || '',
      location: data.location || '',
      product: data.product || '',
      source: data.source || ''
    });
  }

  function finishOpen(context) {
    preferNative = false;
    openDirectLine('conceal');
    confirmOpened();
    publishDirectLine('direct_line_open', context);
  }

  var lastOpenAt = 0;

  function startOpen(trigger) {
    var now = Date.now();
    if (now - lastOpenAt < 900) return;
    lastOpenAt = now;
    var context = contextFrom(trigger);
    if (openDirectLine('open')) {
      finishOpen(context);
      return;
    }
    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      if (openDirectLine('open')) {
        window.clearInterval(timer);
        finishOpen(context);
        return;
      }
      if (tries >= 8) {
        window.clearInterval(timer);
        preferNative = true;
        openDirectLine('reveal');
      }
    }, 300);
  }

  /*
   * Re:amaze renders the post-send ticket bubble as its own list item:
   * li.message.staff.convo-started
   * Real staff replies are li.message.staff and do not use convo-started.
   * Customer messages are li.message.customer.
   * The optional email prompt is #footer > .alert.alert-warning.
   * This style is injected into the Re:amaze iframe only, and only if missing.
   */
  var QUIET_STYLE_ID = 'cc-ask-billy-quiet';
  var QUIET_CSS = [
    'li.message.staff.convo-started { display: none !important; }',
    '#footer > .alert.alert-warning {',
    'background: transparent !important;',
    'background-color: transparent !important;',
    'border: 0 !important;',
    'box-shadow: none !important;',
    'color: #3d4d5c !important;',
    'font-size: 12px !important;',
    'font-weight: 500 !important;',
    'line-height: 1.35 !important;',
    'text-decoration: underline !important;',
    'text-underline-offset: 2px !important;',
    'padding: 2px 12px 0 !important;',
    'margin: 0 8px 4px !important;',
    'border-radius: 0 !important;',
    'cursor: pointer !important;',
    '}'
  ].join('');

  function reamazeFrameDocument() {
    var frame = document.querySelector('#reamaze-wrapper iframe');
    if (!frame) return null;
    try {
      return frame.contentDocument;
    } catch (error) {
      return null;
    }
  }

  function ensureQuietStyle(doc) {
    if (!doc || !doc.documentElement || doc.getElementById(QUIET_STYLE_ID)) return;
    var style = doc.createElement('style');
    style.id = QUIET_STYLE_ID;
    style.textContent = QUIET_CSS;
    (doc.head || doc.documentElement).appendChild(style);
  }

  /*
   * After a successful email handoff, Re:amaze keeps its contact modal
   * over the same thread and only closes it about a second later.
   * The success check is the save signal. Clicking Re:amaze's own
   * overlay runs CLOSE_MODAL and reveals that same thread.
   */
  function returnFromContactHandoff(doc) {
    if (!doc) return;
    var modal = doc.getElementById('rmz-conversation-modal');
    if (!modal || modal.getAttribute('data-cc-handoff-closing') === '1') return;
    if (!modal.querySelector('#transitional-email')) return;
    if (!modal.querySelector('.rmzfa-check')) return;
    var overlay = doc.getElementById('rmz-conversation-modal-overlay');
    if (!overlay) return;
    modal.setAttribute('data-cc-handoff-closing', '1');
    overlay.click();
  }

  function watchReamazeFrame() {
    var hooked = null;
    function hook() {
      var doc = reamazeFrameDocument();
      if (!doc) return;
      ensureQuietStyle(doc);
      returnFromContactHandoff(doc);
      if (doc === hooked || !('MutationObserver' in window)) return;
      hooked = doc;
      new MutationObserver(function () {
        ensureQuietStyle(doc);
        returnFromContactHandoff(doc);
      }).observe(doc.documentElement, { childList: true, subtree: true });
    }
    hook();
    if ('MutationObserver' in window) {
      new MutationObserver(hook).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  function watchViews() {
    if (!('IntersectionObserver' in window)) return;
    var seen = {};
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var location = entry.target.getAttribute('data-cc-location') || 'launcher';
        var source = entry.target.getAttribute('data-cc-source') || location;
        var key = location + '|' + source;
        if (seen[key]) return;
        seen[key] = true;
        publishDirectLine('direct_line_view', contextFrom(entry.target));
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.5 });
    document.querySelectorAll('#cc-direct-line, [data-cc-direct-line-open]').forEach(function (el) {
      observer.observe(el);
    });
  }

  function bind() {
    if (document.documentElement.dataset.ccDirectLine === 'true') return;
    document.documentElement.dataset.ccDirectLine = 'true';

    document.addEventListener('touchend', function (event) {
      var trigger = event.target.closest('#cc-direct-line, [data-cc-direct-line-open]');
      if (!trigger) return;
      startOpen(trigger);
    }, { passive: true });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('#cc-direct-line, [data-cc-direct-line-open]');
      if (!trigger) return;
      event.preventDefault();
      event.stopPropagation();
      startOpen(trigger);
    });

    watchViews();
    watchReamazeFrame();

    var scheduled = false;
    function requestSync() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        syncPage();
      });
    }

    syncPage();
    window.setInterval(requestSync, 750);
    if ('MutationObserver' in window) {
      var watched = [];
      var watcher = new MutationObserver(function () {
        requestSync();
        var widgets = document.querySelectorAll('shopify-chat, inbox-online-store-chat, #ShopifyChat');
        for (var i = 0; i < widgets.length; i++) {
          var root = widgets[i].shadowRoot;
          if (!root || watched.indexOf(root) !== -1) continue;
          watched.push(root);
          watcher.observe(root, { childList: true, subtree: true });
        }
      });
      watcher.observe(document.documentElement, { childList: true, subtree: true });
    }
    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync);
    document.addEventListener('cart-drawer:open', requestSync);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
